const ModalManagerService = require('core/services/ModalManagerService');

const setupModalManagerService = async () => {
  ModalManagerService.init();
};

export default setupModalManagerService;
